import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const DeliveryOnStockTotalQuantityValidator = (
  animalsControlName: string,
  daysControlName: string,
  dosisControlName: string,
  hexTotalDeliveryQuantity: number,
): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const treatingAnimalsNumber = parseFloat(control.get(animalsControlName)?.value);
    const treatmentDays = parseFloat(control.get(daysControlName)?.value);
    const animalDosis = parseFloat(control.get(dosisControlName)?.value);
    
    // Checking if the result of the treatingAnimalsNumber*treatmentDays*animalDosis match the hex units using the Rule of three (value*hexUnits/quantity) 
    const result = (treatingAnimalsNumber * treatmentDays * animalDosis);
  
    if (result !== hexTotalDeliveryQuantity) {
      return {
        invalidTotalQuantity: {
          result,
          actual: result
        }
      };
    }

    return null;
  };
}